export const defaultCartPromocodeModelData = {
  promocode: null,
  isValid: null
};

export const ActionType = {
  APPLY_PROMOCODE: `APPLY_PROMOCODE`,
  SET_INVALID: `SET_INVALID`,
  REMOVE_PROMOCODE: `REMOVE_PROMOCODE`,
  RESET: `RESET`
};

export const CONNECTOR_URL = `/assets/components/promocodes/connector.php`;
export const RequestAction = {
  APPLY_PROMOCODE: `apply_promocode`,
  REMOVE_PROMOCODE: `remove_promocode`
};
export const PROMOCODE_INPUT_NAME = `promocode`;
export const NOTIFICATION_DISPLAY_TIME = 2000;

